import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const DeleteContentSlice = createSlice({
    name: "deleteContentRequest",
    initialState,
    reducers: {
        deleteContentRequest(state) {
            state.loading = true;
        },
        deleteContentRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        deleteContentRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
        deleteContentStateReset(state) {
            state.loading = false;
            state.error = undefined;
            state.response = undefined;
        },
    },
});

export const {
    deleteContentRequest,
    deleteContentRequestSuccess,
    deleteContentRequestError,
    deleteContentStateReset,
} = DeleteContentSlice.actions;

export default DeleteContentSlice.reducer;
